import api from 'api/axiosInstance';
import type {
  CommunicationTypes,
  TransferReasons,
  TransferTypes,
} from 'components/pages/Banks/Wallet/MoneyTransfer/types';
import type { ExpenseInput } from 'components/pages/Expenses/Form';
import type { CurrenciesEnum, Currency } from 'types/global.types';
import type { Paging } from 'types/pagination.types';

export type BasketBody = {
  _id?: string;
  document: {
    id: string;
    type: string;
  };
  type: TransferTypes;
  amount: {
    value: number;
    currency: CurrenciesEnum;
  };
  communication: {
    message: string;
    type: CommunicationTypes;
  };
  beneficiary: {
    name: string;
    iban: string;
  };
  reason: TransferReasons;
};

export type BasketItem = {
  _id: string;
  userId: string;
  document: {
    id: string;
    type: 'expense';
  };
  type: TransferTypes;
  status: 'pending';
  amount: {
    value: number;
    currency: Currency;
  };
  communication: {
    message: string;
    type: CommunicationTypes;
  };
  beneficiary: {
    iban: string;
    name: string;
  };
  created: string;
  modified: string;
  __v: number;
  originalExpense: ExpenseInput;
  isDraft: boolean;
};

export const getBasket = (): Promise<{ items: BasketItem[]; paging: Paging }> =>
  api.get('/v2/accountable-banking/basket/items?perPage=999999');

export const addExpenseToBasket = (body: BasketBody) =>
  api.post('/v2/accountable-banking/basket/items', body);

export const updateExpenseInBasket = (body: BasketBody) => {
  const { _id, ...rest } = body;

  return api.put(`/v2/accountable-banking/basket/items/${_id}`, rest);
};

export const deleteBasketItem = (
  id: string,
): Promise<{ items: BasketItem[]; paging: Paging }> =>
  api.delete(`/v2/accountable-banking/basket/items/${id}`);
